import { Component, Prop, Vue } from 'vue-property-decorator'
import i18n from '@/lang/i18n'

@Component
export default class SectionInfoColType extends Vue {
    @Prop({ type: String })
    readonly label!: string

    @Prop({ type: String, default: () => i18n.tc('globalLocator.labels.notAvailableData') })
    readonly notAvailableLabel!: string

    @Prop({ type: String, default: 'flex-column' })
    readonly colClass!: string

    @Prop()
    readonly data!: any
}
